import Vue from 'vue';

export default {
  name: 'Log',
  props: ['dataObj'],
  data: function () {
    return {
      iForcedLogPerElem: -1,
      sForcedLabel: '',
      bShowConfirm: false,
      readings: {
        items: [],
        groupBatchId: 0,
        readingDate: new Date(),
        readingTime: { hours: 0, minutes: 0, descr: 'logs.ReadingTime' },
        stampDate: new Date(),
        stampUser: this.loggedInUser
      },
    }
  },
  computed: {
    employee: function () {
      return -1;
    },
  },
  watch: {
    stationId: function (value) {
      return 0;
    },
  },
  created() {
    this.init();
    this.$root.$on('log_updated', this.init);
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.readings = this.dataObj;
      });
    },
    getInputClass(iLogPerElem) {
      return (this.iForcedLogPerElem === iLogPerElem) ? 'md-invalid': ''
    },
    onBlur(event) {
      if (this.bShowConfirm === true)
        return;

      this.iForcedLogPerElem = -1;

      var item = this.readings.items.filter(p => p.logPerElementId === event)[0];

      if (!item)
        return;

      if (parseFloat(item.maxReading) < parseFloat(item.value) || parseFloat(item.minReading) > parseFloat(item.value)) {
        this.iForcedLogPerElem = event;
        this.sForcedLabel = item.name;
        this.bShowConfirm = true;
        this.readings.bShowConfirm = true;
      }        
    },
    getForcedContent() {
      return this.$t('logs.DescribeForced1') + this.sForcedLabel + this.$t('logs.DescribeForced2');
    },
    confirmForcedYes() {
      var item = this.readings.items.filter(p => p.logPerElementId === this.iForcedLogPerElem)[0];

      if (item)
        item.isForcedReading = true

      this.bShowConfirm = false;
      this.readings.bShowConfirm = false;
    },
    confirmForcedNo() {
      var item = this.readings.items.filter(p => p.logPerElementId === this.iForcedLogPerElem)[0];

      if (item)
        item.isForcedReading = false

      if (parseFloat(item.maxReading) < parseFloat(item.value))
        item.value = item.maxReading;

      if (parseFloat(item.minReading) > parseFloat(item.value))
        item.value = item.minReading;

      this.bShowConfirm = false;
      this.readings.bShowConfirm = false;
    },
  },
}

